import { useEffect, useMemo, useState } from "react";
import { SearchIcon } from "lucide-react";
import filterOptions from "../DistributorPanel/filterOptions";

export default function EntitySearchSelect({
  options = [],
  value,
  onChange,
  placeholder = "Search",
  isDisabled = false,
}) {
  const [q, setQ] = useState("");

  useEffect(() => {
    if (value?.name) setQ(value.name);
  }, [value]);

  const filtered = useMemo(() => filterOptions(q, options), [q, options]);
  const selected = options.find((o) => o.id === value?.id);

  return (
    <div className={`space-y-2 ${isDisabled ? "opacity-60 pointer-events-none" : ""}`}>
      <div className="flex items-center gap-2 rounded-lg border px-2 py-1.5">
        <SearchIcon size={16} className="opacity-70" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={placeholder}
          className="w-full outline-none text-sm"
          disabled={isDisabled}
        />
      </div>

      <div className="max-h-[7.5rem] overflow-y-auto rounded-lg border">
        {filtered.map((o) => (
          <button
            key={o.id}
            onClick={() => {
              onChange(o);
              setQ(o.name);
            }}
            className={`flex w-full justify-between px-3 py-2 text-sm ${
              selected?.id === o.id ? "bg-slate-50" : ""
            }`}
          >
            <div>
              <div className="font-medium">{o.name}</div>
              <div className="text-xs text-slate-500">{o.org_code}</div>
            </div>
            <span className="text-xs">{o.id}</span>
          </button>
        ))}
      </div>
    </div>
  );
}



// import { useMemo, useState } from "react";

// import { SearchIcon } from "lucide-react";
// import filterOptions from "../DistributorPanel/filterOptions";

// export default function EntitySearchSelect({
//   options = [],
//   value,
//   onChange,
//   placeholder = "Search by id or name",
// }) {
//   const [q, setQ] = useState("");
//   const filtered = useMemo(() => filterOptions(q, options), [q, options]);
//   const selected = useMemo(() => options.find((o) => o.id === value?.id), [options, value]);

//   const handleSelect = (item) => {
//     onChange(item);
//     setQ(item.name || "");
//   };

//   return (
//     <div className="space-y-2">
//       <div className="flex items-center gap-2 rounded-lg border px-2 py-1.5">
//         <SearchIcon size={16} className="opacity-70" />
//         <input
//           value={q}
//           onChange={(e) => setQ(e.target.value)}
//           placeholder={placeholder}
//           className="w-full outline-none text-sm"
//         />
//       </div>

//       <div className="max-h-[7.5rem] overflow-y-auto rounded-lg border">
//         {filtered.length === 0 ? (
//           <div className="p-2 text-xs text-slate-500">No matches…</div>
//         ) : (
//           filtered.map((o) => (
//             <button
//               key={o.id}
//               onClick={() => handleSelect(o)}
//               className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-slate-50 ${
//                 selected?.id === o.id ? "bg-slate-50" : ""
//               }`}
//             >
//               <div className="flex flex-col text-left">
//                 <span className="font-medium">{o.name}</span>
//                 {o.org_code && <span className="text-xs text-slate-500">{o.org_code}</span>}
//               </div>
//               <span className="text-xs text-slate-500">{o.id}</span>
//             </button>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }
